import { render } from "./FullScreen.vue?vue&type=template&id=2af56d60&scoped=true"
import script from "./FullScreen.vue?vue&type=script&lang=ts"
export * from "./FullScreen.vue?vue&type=script&lang=ts"

import "./FullScreen.vue?vue&type=style&index=0&id=2af56d60&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-2af56d60"

export default script